/**
 * Bitget Exchange Metadata
 *
 * Configuration, documentation links, and notes for the Bitget exchange.
 */

import { BITGET_WS_CHANNELS, BITGET_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const BITGET_METADATA: ExchangeMetadata = {
  id: 'bitget' as ExchangeId,
  restDocs: ['https://www.bitget.com/api-doc/spot/market/Get-Tickers'],
  wsDocs: ['https://www.bitget.com/api-doc/spot/websocket/public/Tickers-Channel'],
  wsTopology: BITGET_WS_TOPOLOGY,
  wsChannels: BITGET_WS_CHANNELS,
  notes: [
    'Uses V2 API with JSON-based WebSocket messages.',
    'Supports multiplexing multiple channels on a single connection.',
    'Requires ping message every 30 seconds to keep connection alive.',
  ],
};
